import React from "react";

const InformationalBoxHeavy = ({ title, content, boxNewStyles, titleNewStyles }) => {
  return (
    <>
      <div
        style={{
          width: "100%",
          padding: "25px",
          backgroundColor: "#545f8d",
          textAlign: "center",
          borderRadius: "10px",
          color: "white",
          ...boxNewStyles,
        }}
      >
        {title ? (
          <p style={{ marginBottom: "15px", fontWeight: "bold", ...titleNewStyles }}>{title}</p>
        ) : null}
        {content ? <p>{content}</p> : null}
      </div>
    </>
  );
};

export default InformationalBoxHeavy;
